import { authStore } from "@features/auth/tess-session.store"
import { Button } from "@features/ui/Button"
import { observer } from "mobx-react-lite"
import { flyingCarpetStore } from "../flying-carpet.store"
import { useRPCQuery } from "eddev/hooks"
import { useEffect } from "react"
import { formatDateTime } from "@utils/dates"

export const AccountPanel = observer(() => {
  const account = authStore.account
  const session = authStore.session
  const isLoading = authStore.isSessionLoading
  const signedIn = authStore.isAuthenticated

  useEffect(() => {
    if (!signedIn) {
      flyingCarpetStore.open("signin")
    }
  }, [signedIn])

  if (!signedIn) {
    return null
  }

  return (
    <div className="flex flex-col gap-4 px-shelf py-shelf">
      <div className="type-title-s">Welcome Back</div>
      <div className="type-title-l font-bold">{account?.name || account?.email}</div>
      <div></div>
      {/* <div>{JSON.stringify(account?.email)}</div> */}
      {authStore.lastError && <div className="text-[red]">{authStore.lastError}</div>}
      <AccountInfo />
      <div className="flex gap-2">
        {account ? (
          <Button
            disabled={isLoading}
            onClick={() => {
              authStore.signOut()
            }}
          >
            {isLoading ? "Signing Out" : "Sign Out"}
          </Button>
        ) : (
          <Button onClick={() => flyingCarpetStore.open("signin")}>Sign In</Button>
        )}
      </div>
    </div>
  )
})

const AccountInfo = observer(() => {
  const orderLookup = useRPCQuery(
    "api.public.tess.auth.orders",
    {
      encryptedSessionKey: authStore.encryptedSessionKey!,
    },
    {
      enabled: !!authStore.encryptedSessionKey,
    },
  )

  return (
    <div>
      <h3 className="type-title-s">Orders</h3>
      <div>
        {orderLookup.data?.map((order) => {
          return (
            <div key={order.OrderId} className="border-b">
              #{order.OrderId} - {formatDateTime(order.OrderDate!)}
            </div>
          )
        })}
      </div>
    </div>
  )
})
